import React from 'react';
import { motion } from 'framer-motion';
import { PCGTab } from '../../PCGProfileContainer';
import { Box } from '../../../../wag-react/next-components/box';
import { Typography } from '../../../../wag-react/components/Typography';
type Props = {
  setSelectedTab: React.Dispatch<React.SetStateAction<PCGTab>>;
  selectedTab: PCGTab;
  pcgTabs: PCGTab[];
};
export const WalkerTabs = ({
  setSelectedTab,
  selectedTab,
  pcgTabs
}: Props) => <Box as="nav" position={['relative', null, 'absolute']} bottom="0" zIndex={1} className="lg:translate-x-[60px]" data-sentry-element="Box" data-sentry-component="WalkerTabs" data-sentry-source-file="WalkerTabs.tsx">
    <Box display="flex" alignItems="center" justifyContent="space-between" width={['84%', null, '100%']} minWidth="310px" mx="auto" data-sentry-element="Box" data-sentry-source-file="WalkerTabs.tsx">
      {pcgTabs.map(item => <Box key={item} position="relative" mr={[0, 5]} cursor="pointer" className={item === selectedTab ? 'selected' : ''} onClick={() => setSelectedTab(item)}>
          <Typography variant="body1" fontSize="14px" py="16px" color="#272727" fontFamily="muliBold" m="0" opacity={item === selectedTab ? 1 : 0.5} style={{
        transition: 'opacity 250ms'
      }}>
            {item}
          </Typography>
          {item === selectedTab ? <motion.div className="underline h-[3px] bg-black absolute w-[100%] bottom-0" layoutId="underline" /> : null}
        </Box>)}
    </Box>
  </Box>;